/**
* @file 布局
* @author Ice(chenzhouji@baidu.com)
*/
import React, {FunctionComponent, useState, useEffect, cloneElement} from 'react';
import {graphql, useStaticQuery} from 'gatsby';
import {get} from 'lodash';
import classnames from 'classnames';
import MobileDetect from 'mobile-detect';
import Sider from '@/templates/acg-portal-en/components/Sider';
import Header from '@/templates/acg-portal-en/components/Header';

import '@/templates/acg-portal-en/theme/index.less';

const siteQuery = graphql`
    query SiteAcgPortalEnQuery {
        site {
            siteMetadata {
                name
                description
                repoName
                menuItems
                slugName
                seo
                pdfLink
            }
        }
    }
`;

const createDetector = () => {
    let detector = null;
    try {
        detector = new MobileDetect(window.navigator.userAgent);
    }
    catch (error) {
        detector = null;
    }

    return detector;
}

const Layout: FunctionComponent<any> = props => {

    const {
        name,
        description,
        repoName,
        menuItems,
        slugName,
        seo,
        pdfLink
    }: any = get(
        useStaticQuery(siteQuery),
        'site.siteMetadata',
        {}
    );

    const [className, setClassName] = useState('html');
    const detector = createDetector();

    useEffect(() => {
        const className = classnames({
            html: true,
            ['is-desktop']: detector && !detector.mobile(),
            ['is-mobile']: detector && detector.mobile(),
            ['is-phone']: detector && detector.phone(),
            ['is-tablet']: detector && detector.tablet()
        });

        setClassName(className);
    }, [setClassName]);

    const newProps = {
        ...props,
        name,
        description,
        repoName,
        slugName,
        menuItems: JSON.parse(menuItems),
        seo: seo ? JSON.parse(seo) : {},
        pdfLink
    };

    const api = `https://bce.bdstatic.com/portal-cms/online/doc_en/nav.js?t=${(new Date()).getTime()}`;

    return (
        <div className={className}>
            <Header />
            <div className="body">
                <Sider {...newProps} api={api} template="acg-portal-en" />
                <div className="main">
                {cloneElement(props.children, newProps)}
                </div>
            </div>
        </div>
    );
};

export default Layout;
